var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-button',{attrs:{"slot":"start","fill":"clear","size":"small"},on:{"click":_vm.signout},slot:"start"},[_vm._v("Sign Out")])
}
var staticRenderFns = []

export { render, staticRenderFns }